import ProgressStatusHandleBtn from "../movable/renderer/ProgressStatusHandleBtn";
import React from "react";
import {
    connectedNameRenderer,
    maintenanceAssetNameRenderer,
    progressDailyCheckNameRenderer
} from "../../../packages/maintenance/maintenanceAssetNameRenderer";
import {
    inspectionHeaderProgressRenderer
} from "../../../packages/maintenance/inspection/subPages/inspectionHeaderProgressRenderer";
import {
    inspectionHeaderCycleRenderer
} from "../../../packages/maintenance/inspection/subPages/inspectionHeaderCycleRenderer";
import {
    AssetDepreciationPriceNameRenderer,
    AssetDepreciationProgressBarRenderer, AssetDepreciationYearNameRenderer
} from "../../../packages/asset/finance/depreciation/AssetDepreciationRenderer";
import {userAuthRenderer} from "../../../packages/settings/userAccount/userAccountRenderer";
import {
    ChildrenCountNameRenderer,
    codeTypeNameRenderer,
    countNameRenderer
} from "../../../packages/settings/report/InspectionReportCode/ChildrenCountNameRenderer";
import {assetAndContractCountRenderer, userCountRenderer} from "../../../packages/settings/company/CompanyListRenderer";
import {
    RentalRequestCancelButton,
    RentalRequestTableButtonGroup
} from "../movable/renderer/RentalRequestTableButtonGroup";
import {RentalAssetTableActive, RentalAssetTableButtonGroup} from "../movable/renderer/RentalAssetTableButtonGroup";
import {SimmsMessage} from "../../modal/SimmsMessage";
import {assetNameRenderer, MoveUpdatePage} from "../../../packages/lifecycle/dispose/DisposeListRenderer";
import RentalAssetNameRenderer from "../movable/renderer/RentalAssetNameRenderer";

export const ASSET_LIST_HEADER = [
    {name: "자산명",field: "assetName", width: 200, minWidth: 130},
    {name: "자산코드",field: "assetCode", width: 120, minWidth: 100},
    {name: "자산그룹", field: "groupName", width: 140},
    {name: "업무그룹", field: "taskName", width: 140},
    {name: "자산위치", field: "locationName", width: 140},
    {name: "SLA 그룹", field: "slaGroupName", width: 140},
    {name: "부서", field: "departmentName", width: 140},
    {name: "시스템", field: "projectName", width: 140},
    {name: "1차 업체",  field: "mngPrimaryName", width: 140},
    {name: "2차 업체",  field: "mngSecondaryName", width: 140},
    {name: "3차 업체",  field: "mngTertiaryName", width: 140},
    {name: "도입일자", field: "importDate", width: 140},
    {name: "도입금액", field: "importPrice", width: 140},
    {name: "유지보수액", field: "mngPrice", width: 140},
    {name: "운영담당자", field: "operator", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "자산사용자", field: "handler", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "등록일", field: "createdAt",width: 140},
    {name: "수정일", field: "updatedAt",width: 140},
];

export const ASSET_IAM_LIST_HEADER = [
    {name: "자산명",field: "assetName", width: 200, minWidth: 130},
    {name: "자산코드",field: "assetCode", width: 120, minWidth: 100},
    {name: "자산그룹", field: "groupName", width: 140},
    {name: "업무그룹", field: "taskName", width: 140},
    {name: "자산위치", field: "locationName", width: 140},
    {name: "부서", field: "departmentName", width: 140},
    {name: "시스템", field: "projectName", width: 140},
    {name: "1차 업체",  field: "mngPrimaryName", width: 140},
    {name: "2차 업체",  field: "mngSecondaryName", width: 140},
    {name: "3차 업체",  field: "mngTertiaryName", width: 140},
    {name: "도입일자", field: "importDate", width: 140},
    {name: "도입금액", field: "importPrice", width: 140},
    {name: "유지보수액", field: "mngPrice", width: 140},
    {name: "운영담당자", field: "operator", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "자산사용자", field: "handler", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "등록일", field: "createdAt",width: 140},
    {name: "수정일", field: "updatedAt",width: 140},
];

export const COMPANY_ASSET_LIST_HEADER = [
    {name: "자산명",field: "assetName", width: 200, minWidth: 130},
    {name: "자산코드",field: "assetCode", width: 120, minWidth: 100},
    {name: "자산그룹", field: "group.name", width: 140},
    {name: "업무그룹", field: "task.name", width: 140},
    {name: "자산위치", field: "location.name", width: 140},
    {name: "시스템", field: "project.name", width: 140},
    {name: "1차 업체",  field: "mngPrimary.name", width: 140},
    {name: "2차 업체",  field: "mngSecondary.name", width: 140},
    {name: "3차 업체",  field: "mngTertiary.name", width: 140},
    {name: "도입일자", field: "importDate", width: 140},
    {name: "도입금액", field: "importPrice", width: 140},
    {name: "유지보수액", field: "mngPrice", width: 140},
    {name: "운영자", field: "operator.name", width: 140},
    {name: "사용자", field: "handler.name", width: 140},
    {name: "등록일", field: "createdAt",width: 140},
    {name: "수정일", field: "updatedAt",width: 140},
];

export const ASSET_CURRENT_HEADER = [
    {name: "자산명",field: "assetName", width: 250, minWidth: 150},
    {name: "자산코드",field: "assetCode", width: 100, minWidth: 100},
    {name: "자산그룹", field: "groupName", width: 140},
    {name: "업무그룹", field: "taskName", width: 140},
    {name: "자산위치", field: "locationName", width: 140},
    {name: "부서", field: "departmentName", width: 140},
    {name: "시스템", field: "projectName", width: 140},

    {name: "운영자", field: "operator", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "사용자", field: "handler", width: 140, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},

    {name: "등록일", field: "createdAt",width: 140},
    {name: "수정일", field: "updatedAt",width: 140},
];

export const SERVICE_APPLY_HEADER = [
    {name: "업무그룹", field: "serviceCode.name", width: 180},
    {name: "서비스 신청번호", field: "serialNumber", width: 180},
    // {name: "접수 신청번호", field: "serviceRequest.serialNumber", type: "link", path: "/serviceRequest/serviceRequest", linkId: "serviceRequest.id", width: 110, minWidth: 100},
    {name: "신청제목", field: "title", width: 450},
    {name: "요청자", field: "applier.name", width: 150},
    {name: "진행단계", field: "contentStatus", width: 140, renderer: ProgressStatusHandleBtn},
    {name: "요청마감일", field: "requestCloseDate", width: 150},
    {name: "등록자", field: "createUser.name", width: 100},
    {name: "수정자", field: "updateUser.name", width: 100},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
    // {name: "관리", field: "management", width: 80},
    // {name: "결재현황", field: "approvalStatus", width: 120},
    // {name: "관리", field: "management", width: 80, renderer: (props) => <HandleDeleteBtn {...props} method={deleteItem}/>},
];

export const SERVICE_REQUEST_HEADER = [
    {name: "업무그룹", field: "serviceCode.name", width: 160},
    {name: "서비스 신청번호", field: "serviceApply.serialNumber", type: "link", path: "/serviceRequest/serviceApply", linkId: "serviceApply.id", width: 120},
    {name: "접수 신청번호", field: "serialNumber", width: 120},
    {name: "신청제목", field: "title", width: 400},
    {name: "요청자", field: "applier.name", width: 100},
    {name: "접수자", field: "requester.name", width: 100},
    {name: "진행단계", field: "contentStatus", width: 140, renderer: ProgressStatusHandleBtn},
    {name: "요청마감일", field: "requestCloseDate", width: 150},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "수정자", field: "updatedBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
    // {name: "관리", field: "contentStatus", width: 80, minWidth: 80, renderer: (props) => <ServiceRequestTableButton {...props} />}
    // {name: "관리", field: "management", width: 80},
    // {name: "결제현황", field: "approvalStatus", width: 9},
    // ...(deleteItem ? [{name: "관리", field: "management", width: 80, renderer: (props) => <HandleDeleteBtn {...props} method={deleteItem}/>}] : [])
];

export const DILIGENCE_HEADER = [
    {name: "실사종류", field: "code.name", width: 150},
    {name: "제목", field: "title",  width: 310},
    {name: "실사번호", field: "tickets", width: 200},
    {name: "시작일자", field: "reqStartDate", width: 150},
    {name: "마감일자", field: "reqEndDate", width: 150},
    {name: "담당자", field: "handler.name", width: 150, short: [1,"명"]},
    {name: "요청자", field: "requestedBy.name",  width: 150},
    {name: "진행단계", field: "status", width: 150,  renderer: ProgressStatusHandleBtn},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정일", field: "updatedAt", width: 150}];

export const HISTORY_HEADER = [
    {name: "필드명", field: "fieldNameKr", width: 200},
    {name: "수정전", field: "rawValue", width: 500},
    {name: "수정후", field: "updateValue", width: 500},
    {name: "수정자", field: "createdBy.name", width: 150},
    {name: "수정일", field: "createdAt",width: 240}
];

export const RENTAL_ASSET_HEADER = (handleRefresh) => [
    {name: "자산명", field: "assetName", width: 200, renderer: (props) => <RentalAssetNameRenderer {...props} />},
    {name: "대여가능 상태", field: "activeName", width: 150, renderer: (props) => <RentalAssetTableActive {...props} refresh={handleRefresh}/>},
    {name: "관리", field: "id", width: 150, type: "blocked", renderer: (props) => <RentalAssetTableButtonGroup {...props} refresh={handleRefresh}/>},
    {name: "자산코드", field: "assetCode", width: 150},
    {name: "자산상태", field: "", width: 150},
    {name: "대여그룹", field: "codeName",  width: 150},
    {name: "대여횟수", field: "count",  width: 100},
    {name: "대여자", field: "rentalRequestInfo.rentUserName", width: 150},
    {name: "시작일", field: "startDate", width: 110},
    {name: "종료일", field: "endDate", width: 110},
];

export const RENTAL_REQUEST_ADMIN_HEADER = (handleRefresh) => [
    {name: "자산명", field: "assetName", width: 200, renderer: (props) => <RentalAssetNameRenderer {...props} />},
    {name: "신청상태", field: "rentalTypeName", width: 150},
    {name: "관리", field: "id", width: 200, type: "blocked", renderer: (props) => <RentalRequestTableButtonGroup {...props} refresh={handleRefresh}/>},
    {name: "대여그룹", field: "codeName",  width: 100},
    {name: "대여자", field: "rentUser.name", width: 100},
    {name: "시작일", field: "startDate", width: 100},
    {name: "종료일", field: "endDate", width: 100},
    {name: "대여 승인일", field: "rentApproveDate", width: 120},
    {name: "대여 승인자", field: "rentApprover.name", width: 100},
    {name: "연장일", field: "extendDate", width: 120},
    {name: "연장 승인자", field: "extendApprover.name", width: 100},
    {name: "반납일", field: "returnDate", width: 120},
    {name: "반납 승인자", field: "returnApprover.name", width: 100},
];

export const RENTAL_REQUEST_USER_HEADER = (handleRefresh) => [
    {name: "자산명", field: "assetName", width: 210},
    {name: "신청상태", field: "rentalTypeName", width: 100},
    {name: "관리", field: "id", width: 200, type: "blocked", renderer: (props) => <RentalRequestCancelButton {...props} refresh={handleRefresh}/> },
    {name: "자산코드", field: "assetCode", width: 100},
    {name: "대여그룹", field: "codeName",  width: 100},
    {name: "신청일", field: "createdAt", width: 100},
    {name: "대여자", field: "rentUser.name", width: 100},
    {name: "시작일", field: "startDate", width: 100},
    {name: "종료일", field: "endDate", width: 100},
    {name: "대여 승인자", field: "rentApprover.name", width: 100},
    {name: "연장일", field: "extendDate", width: 100},
    {name: "기간연장 승인자", field: "extendApprover.name", width: 100},
    {name: "반납일", field: "returnDate", width: 100},
    {name: "반납 승인자", field: "returnApprover.name", width: 100},
];

export const ACCESS_LOG_HEADER = [
    {name: "아이디", field: "userIdName", width: 300},
    {name: "이름", field: "userName", width: 300},
    {name: "업체명", field: "company", width: 300},
    {name: "접속IP", field: "userIp", width: 300},
    {name: "접속일", field: "createdAt", width: 380}
];

export const INSPECTION_LIST_HEADER = [
    {name: "점검 종류", field: "inspectCode.name", width: 150},
    {name: "제목", field: "title", width: 370},
    {name: "자산명", field: "maintenanceAssets", width: 200, renderer : maintenanceAssetNameRenderer, unSort : true},
    {name: "요청자", field: "requester.name", width: 150},
    {name: "검수자", field: "inspector.name", width: 150},
    {name: "진행단계", field: "contentStatus", width: 140, renderer : ProgressStatusHandleBtn, unSort : true},
    {name: "점검시작일", field: "inspectStartDate", width: 150},
    {name: "점검종료일", field: "inspectEndDate", width: 150},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
];

export const INSPECTION_HEADER_LIST_HEADER = [
    {name: "정기점검 제목", field: "title", width: 200},
    {name: "선택자산", field: "assetName", width: 200, unSort : true},
    {name: "점검계획자", field: "requester", width: 150},
    {name: "진행률", field: "progress", width: 150, renderer : inspectionHeaderProgressRenderer, unSort : true},
    {name: "검수자", field: "inspector", width: 150},
    {name: "점검주기", field: "inspectCycle", width: 220, renderer: inspectionHeaderCycleRenderer, unSort: true},
    {name: "점검시작일", field: "inspectStartDate", width: 150},
    {name: "점검종료일", field: "inspectEndDate", width: 150},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
];

export const INCIDENT_LIST_HEADER = [
    {name: "장애구분", field: "incidentType", width: 150},
    {name: "장애유형", field: "incidentCode.name", width: 150},
    {name: "장애 일련번호", field: "number", width: 150},
    {name: "제목", field: "title", width: 220},
    {name: "자산명", field: "maintenanceAssets", width: 150, renderer : maintenanceAssetNameRenderer, unSort : true},
    {name: "요청자", field: "requester.name", width: 150},
    {name: "검수자", field: "inspector.name", width: 150},
    {name: "진행단계", field: "contentStatus", width: 140, renderer : ProgressStatusHandleBtn, unSort : true},
    {name: "장애 시작일", field: "incidentStartDate", width: 150},
    {name: "장애 종료일", field: "incidentEndDate", width: 150},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
];

export const WORK_LIST_HEADER = [
    {name: "작업종류", field: "workCode.name", width: 150},
    {name: "작업 일련번호", field: "number", width: 150},
    {name: "제목", field: "title", width: 320},
    {name: "자산명", field: "maintenanceAssets", width: 150, renderer : maintenanceAssetNameRenderer, unSort : true},
    {name: "요청자", field: "requester.name", width: 100},
    {name: "검수자", field: "inspector.name", width: 100},
    {name: "진행단계", field: "contentStatus", width: 140, renderer : ProgressStatusHandleBtn, unSort : true},
    {name: "작업 시작일", field: "workStartDate", width: 150},
    {name: "작업 종료일", field: "workEndDate", width: 150},
    {name: "연계정보 구분", field: "connectedInfo", width: 150, renderer : connectedNameRenderer},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
];

export const INSPECTION_HEADER = [
    {name: "자산명", field: "assetName", width: 150},
    {name: "점검코드", field: "codeName", width: 150},
    {name: "점검제목", field: "name", width: 200},
    {name: "등록자", field: "createdBy", width: 100},
    {name: "검수자", field: "inspector", width: 100},
    {name: "방식", field: "requestCode", width: 100},
    {name: "점검 시작일", field: "startDate",width: 130},
    {name: "점검 종료일", field: "endDate",width: 130},
    {name: "진행단계", field: "progress", width: 100}
]

export const INCIDENT_HEADER = [
    {name: "자산명", field: "assetName", width: 150},
    {name: "장애코드", field: "codeName", width: 150},
    {name: "장애 일련번호", field: "number", width: 120},
    {name: "장애제목", field: "name", width: 200},
    {name: "등록자", field: "createdBy", width: 100},
    {name: "검수자", field: "inspector", width: 100},
    {name: "장애 요청일", field: "startDate",width: 130},
    {name: "장애 마감일", field: "endDate",width: 130},
    {name: "진행단계", field: "progress", width: 100}
]

export const WORK_HEADER = [
    {name: "자산명", field: "assetName", width: 150},
    {name: "작업코드", field: "codeName", width: 150},
    {name: "작업 일련번호", field: "number", width: 120},
    {name: "작업제목", field: "name", width: 180},
    {name: "등록자", field: "createdBy", width: 100},
    {name: "검수자", field: "inspector", width: 100},
    {name: "작업 요청일", field: "startDate",width: 130},
    {name: "작업 마감일", field: "endDate",width: 130},
    {name: "진행단계", field: "progress", width: 100}
]


export const ASSET_MEMO_HEADER = [
    {name: "제목", field: "title", width: 150},
    {name: "기록관리 코드", field: "code.name", width: 80},
    {name: "메모 내용", field: "content", width: 250},
    {name: "등록자", field: "createdBy.name", width: 80},
    {name: "등록일 ", field: "createdAt", width: 80},
    {name: "관리 ", field: "", width: 50, renderer : (props) => <SimmsMessage {...props} buttonName={'상세보기'} />},
];

export const ASSET_MEMO_LINKED_HEADER = [
    {name: "제목", field: "title", width: 180},
    {name: "기록관리 코드", field: "code.name", width: 120},
    {name: "메모 내용", field: "content", width: 280},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 110},
];
export const ASSET_LICENSE_HEADER = [
    {name: "라이선스 명칭", field: "title", width: 266},
    {name: "라이선스 수량", field: "quantity", width: 150},
    {name: "등록자", field: "createdBy.name", width: 200},
    {name: "담당자", field: "handler.name", short: [1,"명"], width: 200},
    {name: "도입 일시", field: "licenseStartDate", width: 200},
    {name: "사용 시작일", field: "reqStartDate", width: 200},
    {name: "사용 종료일", field: "reqEndDate", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const ASSET_CONTRACT_HEADER = [
    {name: "계약종류", field: "type", width: 100},
    {name: "구분", field: "classification", width: 100},
    {name: "계약 번호", field: "number", width: 150},
    {name: "계약명", field: "name", width: 300},
    {name: "업체명", field: "company.name", width: 150},
    {name: "계약시작일", field: "contractStartDate", width: 150},
    {name: "계약종료일", field: "contractEndDate", width: 150},
    {name: "상태", field: "dateDiff", width: 100},
    {name: "담당자", field: "requester.name", width: 100},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정일", field: "updatedAt", width: 150}
];

export const ASSET_LEASE_HEADER = [
    {name: "리스명", field: "name", width: 200},
    {name: "리스 계약차수", field: "contractCount", width: 100},
    {name: "리스 계약번호", field: "number", width: 100},
    {name: "업체명", field: "company.name", width: 100},
    {name: "리스 실행일", field: "leaseStartDate", width: 150},
    {name: "리스 만료일", field: "leaseEndDate", width: 150},
    {name: "취득원가", field: "cost", width: 150},
    {name: "1회 리스료(10회)", field: "price", width: 150}
];

export const ASSET_MAINTENANCE_HEADER = [
    {name: "구분", field: "type", width: 100},
    {name: "제목", field: "title", width: 100},
    {name: "상태", field: "progress", width: 100},
    {name: "등록일", field: "createdAt", width: 150}
];

export const ASSET_DEPRECIATION_CALC_HEADER = [
    {name: "상각년도", field: "year", width: 150},
    {name: "년차구분", field: "annual", width: 150},
    {name: "감가상각비", field: "amount", width: 150},
    {name: "감가상각 누계액", field: "accumulated", width: 150},
    {name: "장부 자산가치", field: "remain", width: 150},
];

export const NOTIFICATION_HEADER = [
    {name: "카테고리", field:"categoryKorValue", width: 200},
    {name: "알림종류", field: "alarmTypeKorValue", width: 200},
    {name: "수신자", field: "toUser.name", width: 200},
    {name: "내용", field: "description", width: 690},
    {name: "등록자", field: "createdBy.name", width: 150},
    {name: "등록일", field: "createdAt", width: 150, },
];

export const ASSET_CONTRACT_LIST_HEADER = [
    {name: "계약종류", field: "type", width: 100},
    {name: "구분", field: "classification", width: 100},
    {name: "계약 번호", field: "number", width: 150},
    {name: "계약명", field: "name", width: 300},
    {name: "업체명", field: "company.name", width: 150},
    {name: "계약시작일", field: "contractStartDate", width: 130},
    {name: "계약종료일", field: "contractEndDate", width: 130},
    {name: "상태", field: "dateDiff", width: 100},
    {name: "담당자", field: "requester.name", width: 100},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 130},
    {name: "수정일", field: "updatedAt", width: 130}
];

export const ASSET_DEPRECIATION_LIST_HEADER = [
    {name: "자산명", field: "asset.assetName", width: 200},
    {name: "자산그룹", field: "asset.group.name", width: 150},
    {name: "업무그룹", field: "asset.task.name", width: 150},
    {name: "담당자", field: "asset.operator", width: 200, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "계산방법", field: "type", width: 100},
    {name: "내용연수", field: "year", width: 100, renderer : AssetDepreciationYearNameRenderer},
    {name: "감가상각률", field: "rate", width: 100},
    {name: "취득일자", field: "depreciationDate", width: 150},
    {name: "취득가액", field: "price", width: 150, renderer : AssetDepreciationPriceNameRenderer},
    {name: "감가상각", field: "depreciation", width: 150, renderer : AssetDepreciationProgressBarRenderer},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const ASSET_EOS_LIST_HEADER = [
    {name: "자산명", field: "assetName", width: 250},
    {name: "EOS만료", field: "endOfServiceDiff", width: 150},
    {name: "EOS날짜", field: "endOfService", width: 150},
    {name: "자산코드", field: "assetCode", width: 150},
    {name: "자산그룹", field: "group.name", width: 150},
    {name: "업무그룹", field: "task.name", width: 150},
    {name: "자산위치", field: "location.name", width: 150},
    {name: "시스템", field: "project.name", width: 150},
    {name: "운영자", field: "operator", width: 150, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "사용자", field: "handler", width: 150, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
];

export const EVALUATION_REPORT_LIST_HEADER = [
    {name: "작성시작일", field: "startDate", width: 130},
    {name: "작성종료일", field: "endDate", width: 130},
    {name: "제목", field: "name", width: 750},
    {name: "등록자", field: "createdBy.name", width: 200},
    {name: "결재현황", field: "contentStatus.statusKorValue", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const EVALUATION_INSPECTION_LIST_HEADER = [
    {name: "점검종류", field: "codeName", widthPct: "8%"},
    {name: "점검제목", field: "title", widthPct: "19%"},
    {name: "자산정보", field: "assetName", widthPct: "19%"},
    {name: "점검계획일", field: "inspectStartDate", type: "date", widthPct: "12%"},
    {name: "점검완료일", field: "inspectEndDate", type: "date", widthPct: "12%"},
    {name: "진행단계", field: "statusKorValue", widthPct: "10%"},
    {name: "점검자", field: "inspectorName", widthPct: "12%"},
]

export const EVALUATION_INCIDENT_LIST_HEADER = [
    {name: "장애유형", field: "codeName", widthPct: "8%"},
    {name: "장애구분", field: "incidentType", widthPct: "8%"},
    {name: "장애제목", field: "title", widthPct: "16%"},
    {name: "자산정보", field: "assetName", widthPct: "16%"},
    {name: "장애요청일", field: "incidentStartDate", type: "date", widthPct: "12%"},
    {name: "장애완료일", field: "incidentEndDate", type: "date", widthPct: "12%"},
    {name: "진행단계", field: "statusKorValue", widthPct: "9%"},
    {name: "점검자", field: "inspectorName", widthPct: "11%"},
]

export const EVALUATION_WORK_LIST_HEADER = [
    {name: "작업종류", field: "codeName", widthPct: "8%"},
    {name: "연계정보구분", field: "workConnectedInfo", widthPct: "8%"},
    {name: "작업제목", field: "title", widthPct: "16%"},
    {name: "자산정보", field: "assetName", widthPct: "16%"},
    {name: "작업요청일", field: "workStartDate", type: "date", widthPct: "12%"},
    {name: "작업완료일", field: "workEndDate", type: "date", widthPct: "12%"},
    {name: "진행단계", field: "statusKorValue", widthPct: "9%"},
    {name: "점검자", field: "inspectorName", widthPct: "11%"},
]

export const EVALUATION_SERVICE_LIST_HEADER = [
    {name: "서비스요청 업무그룹", field: "codeName", widthPct: "9%"},
    {name: "요청제목", field: "title", widthPct: "18%"},
    {name: "요청자", field: "applierName", widthPct: "9%"},
    {name: "처리담당자", field: "inProgressUserName", widthPct: "9%"},
    {name: "이관담당자", field: "transferer", widthPct: "9%"},
    {name: "등록일", field: "startDate", type: "date", widthPct: "10%"},
    {name: "요청마감일", field: "requestCloseDate", type: "date", widthPct: "10%"},
    {name: "진행단계", field: "statusKorValue", widthPct: "8%"},
    {name: "만족도", field: "feedbackRating", type: "feedback", widthPct: "10%"},
]

export const ASSET_HISTORY_LIST_HEADER = [
    {name: "자산명", field: "assetName", width: 280, unSort: true},
    {name: "필드명", field: "fieldNameKr", width: 150},
    {name: "타입", field: "type", width: 100, renderer : (data) => `${data.data === 'C' ? '등록' : data.data === 'U' ? '수정' : '삭제'}`},
    {name: "수정전", field: "rawValue", width: 400},
    {name: "수정후", field: "updateValue", width: 400},
    {name: "수정자", field: "createdBy.name", width: 100},
    {name: "수정일", field: "createdAt",width: 150}
];

export const ASSET_LEASE_LIST_HEADER = [
    {name: "리스명", field: "name", width: 200},
    {name: "리스 계약차수", field: "contractCount", width: 200},
    {name: "리스 계약번호", field: "number", width: 200},
    {name: "업체명", field: "company.name", width: 150},
    {name: "리스 실행일", field: "leaseStartDate", width: 200},
    {name: "리스 만료일", field: "leaseEndDate", width: 200},
    {name: "취득원가", field: "cost", width: 200},
    {name: "1회 리스료(10회)", field: "price", width: 200}
];

export const DAILY_CHECK_REPORT_LIST_HEADER = [
    {name: "체크일", field: "checkDate", width: 250},
    {name: "일일체크명", field: "dailyCheck.name", width: 550},
    {name: "등록자", field: "createdBy.name", width: 250},
    {name: "결재현황", field: "process", width: 250, renderer : progressDailyCheckNameRenderer},
    {name: "등록일", field: "createdAt", width: 130},
    {name: "수정일", field: "updatedAt", width: 130}
];

export const USER_ACCOUNT_LIST_HEADER = [
    {name: "사용자권한", field: "roles", width: 150, renderer : userAuthRenderer, type : "children", unSort : true},
    {name: "이름 ", field: "name", width: 150},
    {name: "아이디", field: "username", width: 160},
    {name: "직급", field: "position", width: 150},
    {name: "업체", field: "company.name", width: 150},
    {name: "부서", field: "department.name", width: 150},
    {name: "사번", field: "employeeNumber", width: 150},
    // {name: "담당PM", field: "pmInCharge.name", width: 150},
    {name: "이메일", field: "email", width: 150},
    {name: "직통번호", field: "phoneNumber", width: 150},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const INSPECTION_REPORT_CODE_LIST_HEADER = [
    {name: "코드 구분", field: "reportCode", width: 150, renderer : codeTypeNameRenderer},
    {name: "코드 타입", field: "reportCodeText", width: 150},
    {name: "점검보고서 명", field: "name", width: 500},
    {name: "항목정보(건)", field: "children", width: 150, renderer : ChildrenCountNameRenderer, unSort : true},
    {name: "등록자", field: "createdBy.name", width: 150},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정자", field: "updatedBy.name", width: 150},
    {name: "수정일", field: "updatedAt", width: 150},
];


export const COMPANY_USER_LIST_HEADER = [
    {name: "사용자권한", field: "userGroupName", width: 9},
    {name: "이름", field: ["name", "remainDays"], width: 8, minWidth: 150},
    {name: "아이디", field: "username", width: 8, minWidth: 100},
    {name: "직급", field: "position", width: 8},
    {name: "업체", field: "companyName", width: 8},
    {name: "부서", field: "departmentName", width: 8},
    {name: "사번", field: "employeeNumber", width: 8},
    {name: "담당PM", field: "pmInChargeName", width: 8},
    {name: "이메일", field: "email", width: 10},
    {name: "직통번호", field: "phoneNumber", width: 10},
    {name: "등록일&수정일", field: ["createdAt", "updatedAt"], minWidth: 200, width: 10}
];

export const SLA_REPORT_LIST_HEADER = [
    {name: "평가월", field: "month", width: 220, renderer : (data) => `${data.data} 월`},
    {name: "종합평가점수 (수행사)", field: "evaluationResult", width: 220, renderer : (data) => `${data.data} %`},
    {name: "종합평가점수 (고객사)", field: "customerEvaluationResult", width: 220, renderer : (data) => `${data.data ? data.data + ' %' : ''}`},
    {name: "등록자", field: "createdBy.name", width: 220},
    {name: "수정자", field: "updatedBy.name", width: 220},
    {name: "등록일", field: "createdAt", width: 230},
    {name: "최종수정일", field: "updatedAt", width: 230}
];

export const DAILY_CHECK_CODE_LIST_HEADER = [
    {name: "일일체크코드 명", field: "name", width: 200},
    {name: "항목건수", field: "children", width: 200, renderer : ChildrenCountNameRenderer, unSort : true},
    {name: "사용건수", field: "useCount", width: 200, renderer : countNameRenderer},
    {name: "설명", field: "etc", width: 560},
    {name: "등록자", field: "createdBy.name", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const COMMON_HISTORY_LIST_HEADER = [
    {name: "메뉴", field: "entityName", width: 190},
    {name: "문서번호", field: "entityId", width: 100},
    {name: "필드명", field: "fieldNameKr", width: 200},
    {name: "타입", field: "type", width: 100, renderer : (data) => `${data.data === 'C' ? '등록' : data.data === 'U' ? '수정' : '삭제'}`},
    {name: "수정전", field: "rawValue", width: 350},
    {name: "수정후", field: "updateValue", width: 350},
    {name: "수정자", field: "createdBy.name", width: 100},
    {name: "수정일", field: "createdAt",width: 200}
];

export const COMPANY_LIST_HEADER = [
    {name: "회사명칭", field: "name", width: 200},
    {name: "관리번호", field: "number", width: 100},
    {name: "사무실번호", field: "officePhone", width: 150},
    {name: "비상연락망", field: "emergencyPhone", width: 150},
    {name: "대표연락처", field: "employeeContact", width: 150},
    {name: "팩스번호", field: "fax", minWidth: 150, width: 150},
    {name: "홈페이지", field: "uri", width: 100},
    {name: "이메일", field: "email", width: 100},
    {name: "운영여부", field: "operation", width: 90},
    {name: "업체주소", field: "address", width: 100},
    {name: "직원수", field: "userCount", width: 80, renderer : userCountRenderer, unSort : true},
    {name: "운영자산", field: "assetCount", width: 90, renderer : assetAndContractCountRenderer, unSort : true},
    {name: "계약정보", field: "contractCount", width: 100, renderer : assetAndContractCountRenderer, unSort : true},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정일", field: "updatedAt", width: 150}
];

export const LICENSE_LIST_HEADER = [
    {name: "라이선스 명칭", field: "title", width: 200},
    {name: "라이선스 수량", field: "quantity", width: 150},
    {name: "등록자", field: "createdBy.name", width: 200},
    {name: "담당자", field: "handler", width: 200, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "도입 일시", field: "licenseStartDate", width: 200},
    {name: "사용 시작일", field: "reqStartDate", width: 200},
    {name: "사용 종료일", field: "reqEndDate", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120}
];

export const COMPUTER_ROOM_ACCESS_LIST_HEADER = [
    {name: "소속", field: "affiliation", width: 100},
    {name: "직위", field: "position", width: 100},
    {name: "성명", field: "name", width: 100},
    {name: "연락처", field: "phoneNumber",  width: 150},
    {name: "방문위치", field: "visitLocation",  width: 100},
    {name: "방문 목적", field: "visitPurpose", width: 300},
    {name: "입실 시간", field: "checkInAt", width: 160},
    {name: "퇴실 시간", field: "checkOutAt", width: 160},
    {name: "결재상태", field: "approvalType", width: 100},
    {name: "결재자", field: "approverName", width: 100},
    {name: "결재시간", field: "approvalAt", width: 160}

];

export const EQUIPMENT_ACCESS_LIST_HEADER = [
    {name: <><div>구분</div><div><span style={{color: '#A9A9A9'}}>(출/입)</span></div></>, field: "ioCheck", width: 5},
    {name: "반출입 일시", field: "createdAt", width: 8},
    {name: <><div>장비명</div><div><span style={{color: '#A9A9A9'}}>(제조사,제품명)</span></div></> , field: "equipmentName", width: 5},
    {name: <><div>관리번호</div><div><span style={{color: '#A9A9A9'}}>(시리얼번호)</span></div></>, field: "managementNumber",  width: 8},
    {name: "사용자", field: "name",  width: 5},
    {name: "용도", field: "purpose", width: 5},
    {name: "비공개 중요 자료\n완전 삭제 확인", field: "deleteCheck", width: 5},
    {name: "악성코드 감염\n여부 확인", field: "infectionCheck", width: 5}

];

export const PURCHASE_LIST_HEADER = [
    {name: "구매정보 명칭", field: "title", width: 200},
    {name: "구매번호", field: "purchaseNumber", width: 200},
    {name: "구매수량", field: "purchaseQuantity", width: 150},
    {name: "공급업체", field: "company.name", width: 200},
    {name: "등록자", field: "createdBy.name", width: 200},
    {name: "담당자", field: "handler", width: 200, unSort : true, renderer : (data) => !data.data?.length ? "" : data.data.length === 1 ? data.data[0].name : `${data.data[0].name} 외 ${data.data.length - 1}명`},
    {name: "구매 일시", field: "purchaseStartDate", width: 200},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정일", field: "updatedAt", width: 150}
];

export const NOTICE_LIST_HEADER = [
    {name: "제목", field: "subject", width: 420},
    {name: "내용", field: "content", width: 550},
    {name: "등록자", field: "createdBy.name", width: 150},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정자", field: "updatedBy.name", width: 150},
    {name: "수정일", field: "updatedAt", width: 150},
];

export const BULLENTIN_BOARD_LIST_HEADER = [
    {name: "제목", field: "subject", width: 420},
    {name: "내용", field: "content", width: 500},
    {name: "등록자", field: "createdBy.name", width: 150},
    {name: "등록일", field: "createdAt", width: 150},
    {name: "수정자", field: "updatedBy.name", width: 150},
    {name: "수정일", field: "updatedAt", width: 150},
];

export const INTRODUCTION_LIST_HEADER = [
    {name: "코드명", field: "requestCode.name", width: 100},
    {name: "요청코드", field: "number", width: 100},
    {name: "요청제목", field: "name", width: 300},
    {name: "요청자", field: "requester.name", width: 100},
    {name: "검수자", field: "inspector.name", width: 100},
    {name: "운영담당자", field: "operator.name", width: 100},
    {name: "요청시작일", field: "requestStartDate", width: 120},
    {name: "요청마감일", field: "requestEndDate", width: 120},
    // {name: "진행단계", field: "status.statusKorValue", width: 100},
    {name: "진행단계", field: "status", width: 140, renderer : ProgressStatusHandleBtn},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "수정자", field: "updatedBy.name", width: 100},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
    // {name: "관리", field: "status", width: 80, minWidth: 80, block : true, renderer: (props) => <MoveUpdatePage {...props} url={"/lifecycle/introduction/update"} />}
];

export const DISPOSE_LIST_HEADER = [
    {name: "코드명", field: "requestCode.name", width: 120},
    {name: "요청코드", field: "number", width: 100},
    {name: "요청제목", field: "name", width: 200},
    {name: "자산명", field: "assets", width: 200, renderer : assetNameRenderer},
    {name: "요청자", field: "requester.name", width: 100},
    {name: "검수자", field: "inspector.name", width: 100},
    {name: "등록자", field: "createdBy.name", width: 100},
    {name: "수정자", field: "updatedBy.name", width: 100},
    {name: "진행단계", field: "status", width: 140, renderer : ProgressStatusHandleBtn},
    {name: "폐기일", field: "verificationCloseDate", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
    // {name: "관리", field: "status", width: 80, minWidth: 80, block : true, renderer: (props) => <MoveUpdatePage {...props} url={"/lifecycle/dispose/update"} />}
];

export const DISPOSE_ASSET_LIST_HEADER = [
    {name: "코드명", field: "dispose.requestCode.name", width: 150},
    {name: "요청코드", field: "dispose.number", width: 120},
    {name: "요청제목", field: "dispose.name", width: 300},
    {name: "자산명", field: "asset.assetName", width: 300},
    {name: "요청자", field: "dispose.requester.name", width: 120},
    {name: "검수자", field: "dispose.inspector.name", width: 120},
    {name: "등록자", field: "dispose.createdBy.name", width: 120},
    {name: "수정자", field: "dispose.updatedBy.name", width: 120},
    {name: "폐기일", field: "disposeDate", width: 200}
];


export const CLAIM_LIST_HEADER = [
    {name: "요청명",field: "name", width: 200, minWidth: 130},
    {name: "요청분류",field: "code.name", width: 120},
    {name: "요청번호",field: "number", width: 120},
    {name: "요청자", field: "requester.name", width: 100},
    {name: "검수자", field: "reviewer.name", width: 100},
    {name: "담당자", field: "operator.name", width: 100},
    {name: "진행상태", field: "createdBy.name", width: 140},
    {name: "요청일 & 만료일", field: ["reqStartDate", "reqEndDate"], label:["시작 : ","만료 : "], type:"dateArray", width: 200},
    {name: "등록일", field: "createdAt", width: 120},
    {name: "수정일", field: "updatedAt", width: 120},
];